import React from "react";
import { useTrack } from "@/Logigate/hooks/useTrack";
import { SeletorDoGrupo } from "./SeletorDoGrupo";

interface Estabelecimento {
    id: number;
    nome: string;
}

interface Props {
    estabelecimentos: Estabelecimento[];
    estabelecimentoSelecionadoId: number;
    onEstabelecimentoChange?: (estabelecimento: Estabelecimento, menu: any[]) => void;
}

/**
 * A loja do grupo «Humbi Shop». Guarda a escolha neste aparelho e, ao abrir, se a loja guardada
 * não for a que veio do servidor, pede logo o submenu dela (`humbi_shop/menu/{id}`).
 */
export default function EstabelecimentoSeletor({ estabelecimentos, estabelecimentoSelecionadoId, onEstabelecimentoChange }: Props) {
    const { track } = useTrack("humbi_shop");

    return (
        <SeletorDoGrupo
            itens={estabelecimentos}
            selecionadoId={estabelecimentoSelecionadoId}
            chaveGuardada="humbi_shop_estabelecimento_id"
            pedirGuardadaAoMontar
            caminhoMenu={(id) => `/humbi_shop/menu/${id}`}
            icone="mdi:storefront-outline"
            rotulo="Loja"
            placeholder="Escolher a loja"
            nadaEncontrado="Sem lojas"
            textoErro="Não foi possível carregar o menu da loja. Tenta de novo."
            aoEscolher={(loja) => track("clicou", "humbi_shop_selecionar_estabelecimento", { md: { estabelecimento_id: loja.id, estabelecimento_nome: loja.nome } })}
            onTrocar={onEstabelecimentoChange}
        />
    );
}
